import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpHeaders,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HelperService } from '../public/helper.service';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  constructor(private helper: HelperService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    let requestUrl = request.url;
    // if the request URL have the string prefix,
    // then make the replace by the correct url
    if (this.helper.isMobileApp()) {
      if (requestUrl.indexOf('/api/') !== -1) {
        requestUrl = environment.adminHostURL + requestUrl;
      } else if (requestUrl.indexOf('api/') !== -1) {
        requestUrl = environment.adminHostURL + '/' + requestUrl;
      }
    }

    const headers = this.normalizeHeaderXreferer(request.headers);

    // clone the http request
    request = request.clone({
      url: requestUrl,
      headers: headers,
    });
    // move to next HttpClient request life cycle
    return next.handle(request);
  }

  /**
   * Moves the `X-Referer` header onto the tenant origin, keeping path, query and fragment.
   * The path must survive: the backend detects staff order capture by `/capture/` in this value.
   * The URL is rebuilt, not mutated, because setting `protocol` is a no-op for the iOS
   * `httpsionic://` scheme (#11511).
   */
  private normalizeHeaderXreferer(headers: HttpHeaders): HttpHeaders {
    const base = this.helper.isMobileApp()
      ? environment.tenantDomain
      : window.location.origin;

    let finalReferer = base;
    const old = headers.get('X-Referer');

    if (old) {
      try {
        const oldUrl = new URL(old);
        const baseUrl = new URL(base);

        // resolve against the base so its scheme and host always win;
        // collapse leading slashes, since a `//` path would replace the host
        finalReferer = new URL(
          (oldUrl.pathname + oldUrl.search + oldUrl.hash).replace(/^\/+/, '/'),
          baseUrl,
        ).href;
      } catch {
        finalReferer = base;
      }
    }

    return headers.set('X-Referer', finalReferer);
  }
}
